import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer1 from "../components/Footer1";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Profile.css";

const Profile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserProfile();
    window.scrollTo(0, 0);
  }, []);

  const fetchUserProfile = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/signUp"); // Redirect if not logged in
      return;
    }

    try {
      const res = await axios.get("http://localhost:8080/api/auth/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(res.data);
    } catch (err) {
      console.error("Error fetching profile:", err);
      // If token is invalid, force logout
      handleLogout(); 
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (confirmLogout) {
      localStorage.removeItem("authToken"); // Clear Token
      navigate("/signUp"); // Go to Sign up/Login page
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>Loading Profile...</p>
      </div>
    );
  }

  return (
    <>
      {/* <Navbar /> */}
      <div className="profile-page-container">
        
        <div className="profile-header">
          {/* <div className="profile-avatar">
            {user?.name?.charAt(0).toUpperCase()}
          </div> */}
          <h1 className="profile-name">Hello, {user?.name}</h1>
          <p className="profile-email">{user?.email}</p>
        </div>

        <div className="profile-content">
          
          {/* User Details Section */}
          <div className="details-card">
            <h3>Account Details</h3>
            <div className="detail-row">
              <span>User ID:</span>
              <strong>{user?.userId || "N/A"}</strong>
            </div>
            <div className="detail-row">
              <span>Mobile:</span>
              <strong>{user?.mobile}</strong>
            </div>
            <div className="detail-row">
              <span>Country:</span>
              <strong>{user?.country}</strong>
            </div>
            <div className="detail-row">
              <span>Role:</span>
              <span className="role-badge">{user?.role}</span>
            </div>
          </div>

          {/* Dashboard Actions Grid */}
          <div className="dashboard-grid">
            
            <div className="dashboard-card" onClick={() => navigate("/myOrders")}>
              <div className="card-icon">
                <i className="fa-solid fa-box-open"></i>
              </div>
              <div className="card-text">
                <h4>My Orders</h4>
                <p>Track, view, and buy again</p>
              </div>
              <i className="fa-solid fa-chevron-right arrow"></i>
            </div>

            <div className="dashboard-card" onClick={() => navigate("/myOffers")}>
              <div className="card-icon">
                <i className="fa-solid fa-gavel"></i>
              </div>
              <div className="card-text">
                <h4>My Offers</h4>
                <p>Check negotiation status</p>
              </div>
              <i className="fa-solid fa-chevron-right arrow"></i>
            </div>

            <div className="dashboard-card" onClick={() => navigate("/wishlist")}>
              <div className="card-icon">
                <i className="fa-solid fa-heart"></i>
              </div>
              <div className="card-text">
                <h4>Wishlist</h4>
                <p>Your favorite paintings</p>
              </div>
              <i className="fa-solid fa-chevron-right arrow"></i>
            </div>

            {/* Logout Option */}
            <div className="dashboard-card logout-card" onClick={handleLogout}>
              <div className="card-icon">
                <i className="fa-solid fa-right-from-bracket"></i>
              </div>
              <div className="card-text">
                <h4>Log Out</h4>
                <p>Sign out from this device</p>
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer1 />
    </>
  );
};

export default Profile;